import Vue from 'vue'
import Vuex from 'vuex'
import briefsOverviewModule from './modules/content-briefs/briefsOverviewModule'
import briefContentModule from './modules/content-briefs/briefContentModule'
import rankZoneCommonModule from './modules/rank-zone/common'
import rankZoneOverviewModule from './modules/rank-zone/overview'
import rankZoneCompetitionModule from './modules/rank-zone/competition'
import rankZoneUrlModule from './modules/rank-zone/url'
import rankZoneSectionModule from './modules/rank-zone/section'
import rankZoneStatusModule from './modules/rank-zone/status'
import rankZoneProgressModule from './modules/rank-zone/progress'
import rankZoneKeywordMovementModule from './modules/rank-zone/keywordMovement'
import rankZoneKeywordMovementHistoryModule from './modules/rank-zone/keywordMovementHistory'
import attributeReportModule from './modules/attribute'
import agencyModeDataModule from './modules/agency-mode-data'
import relevancyReportModule from './modules/relevancy'
import urlPlanningModule from './modules/url-planner'
import breadcrumbModule from './modules/breadcrumb/breadCrumbModule'
import usersModule from './modules/users'
import calendarModule from './modules/calendar'
import dashboardModule from './modules/dashboard'
import keywordRankingReportModule from './modules/keyword-ranking-report'
import urlRankingReportModule from './modules/url-ranking-report'
import productGridReportModule from './modules/product-grid-report'
import linksModule from './modules/links'
import integratonModule from './modules/integrations'
import statusModule from './modules/status'
import categoryModule from './modules/category'
import sectionsModule from './modules/sections'
import reportingModule from './modules/reporting'
import clientNoteModule from './modules/client-note'
import keywordAttributesModule from './modules/keyword-attributes'
import importerModule from './modules/importer'
import linksCrudModule from './modules/links-crud'
import rankReportsModule from './modules/rank-reports'
import serpTrackerModule from './modules/serp-tracker'
import serpViewHistoryModule from './modules/serp-tracker/viewHistory'
import webPropertyModule from './modules/web-property'
import projectSettingsModule from './modules/project-settings'
import keywordCensusModule from './modules/keyword-census'
import userManagerModule from './modules/user-manager'
import urlAttributesModule from './modules/url-attributes'
import agencyModule from './modules/agency'
import clientsModule from './modules/clients'
import urlCensusModule from './modules/url-census'
import authModule from './modules/auth'
import backgroundTasksModule from './modules/background-tasks'
import accountSetupModule from './modules/account-setup'
import authorizationModule from './modules/authorization'
import _ from 'lodash'
import httpService from '../services/httpService'
import StorageService from '../services/storageService'
import router from '../router'

const storageService = new StorageService()

export const types = {
  ADD_CLIENTS: 'base/ADD_CLIENTS',
  ADD_AGENCIES: 'base/ADD_AGENCIES',
  ADD_CURRENT_USER: 'base/ADD_CURRENT_USER',
  ADD_STATUSES: 'base/ADD_STATUSES',
  SET_SELECTED_CLIENT: 'base/SET_SELECTED_CLIENT',
  UPDATE_CURRENT_USER: 'base/UPDATE_CURRENT_USER',
  ADD_ROLES: 'base/ADD_ROLES',
  CHANGE_FETCHED_STATUS: 'base/CHANGE_FETCHED_STATUS',
  // ADD_ADMIN_CLIENTS: 'base/ADD_ADMIN_CLIENTS',
  ADD_ADMIN_ROUTES: 'base/ADD_ADMIN_ROUTES',
  ADD_URL_STATUSES: 'base/ADD_URL_STATUSES',
  ADD_USER_ROLES: 'base/ADD_USER_ROLES',
  ADD_UNHASHED_CLIENT_ID: 'base/ADD_UNHASHED_CLIENT_ID',
  CHANGE_AGENCY_MODE: 'base/CHANGE_AGENCY_MODE',
  ADD_CONTENT_BRIEF_STATUSES: 'base/ADD_CONTENT_BRIEF_STATUSES',
  ADD_USER_GROUPS: 'base/ADD_USER_GROUPS',
  ADD_STRIPE_PRODUCTS: 'base/ADD_STRIPE_PRODUCTS',
  UPDATE_COMPANY_GUIDELINE: 'base/UPDATE_COMPANY_GUIDELINE',
  TOGGLE_FETCHED_STATUS: 'base/TOGGLE_FETCHED_STATUS',
  TOGGLE_UPDATING_STATUS: 'base/TOGGLE_UPDATING_STATUS',
  TOGGLE_COLLAPSED_STATUS: 'base/TOGGLE_COLLAPSED_STATUS',
  CHANGE_CHAT_STATUS: 'base/CHANGE_CHAT_STATUS',
  ADD_ALLOWED_ROUTES: 'base/ADD_ALLOWED_ROUTES',
  ADD_APPLICATION_ROUTES: 'base/ADD_APPLICATION_ROUTES',
}

const AGENCY_ROLES = ['agency_user', 'agency_admin', 'admin']

/**
 * Root store, combine store modules
 */
Vue.use(Vuex)
const EMPTY_USER = {
  userRoles: [],
  isClientCollaborator () {
    return (
      this.current_role_name === 'client_collaborator' &&
      !AGENCY_ROLES.some(v => this.userRoles.includes(v))
    ) || this.isClientContributor()
  },
  isClientContributor () {
    return this.current_role_name === 'client_contributor' && !AGENCY_ROLES.some(v => this.userRoles.includes(v))
  }
}
export default new Vuex.Store({
  modules: {
    briefsOverview: briefsOverviewModule,
    briefContent: briefContentModule,
    rankZoneCommon: rankZoneCommonModule,
    rankZoneOverview: rankZoneOverviewModule,
    rankZoneCompetition: rankZoneCompetitionModule,
    rankZoneUrl: rankZoneUrlModule,
    rankZoneSection: rankZoneSectionModule,
    rankZoneStatus: rankZoneStatusModule,
    rankZoneProgress: rankZoneProgressModule,
    rankZoneKeywordMovement: rankZoneKeywordMovementModule,
    rankZoneKeywordMovementHistory: rankZoneKeywordMovementHistoryModule,
    relevancyReport: relevancyReportModule,
    agencyModeData: agencyModeDataModule,
    attributeReport: attributeReportModule,
    urlPlanning: urlPlanningModule,
    breadcrumb: breadcrumbModule,
    users: usersModule,
    calendar: calendarModule,
    dashboard: dashboardModule,
    links: linksModule,
    integrations: integratonModule,
    keywordRankingReport: keywordRankingReportModule,
    urlRankingReport: urlRankingReportModule,
    productGridReport: productGridReportModule,
    status: statusModule,
    category: categoryModule,
    sections: sectionsModule,
    reporting: reportingModule,
    clientNote: clientNoteModule,
    keywordAttributes: keywordAttributesModule,
    importer: importerModule,
    linksCrud: linksCrudModule,
    rankReports: rankReportsModule,
    serpTracker: serpTrackerModule,
    serpViewHistory: serpViewHistoryModule,
    webProperty: webPropertyModule,
    projectSettings: projectSettingsModule,
    keywordCensus: keywordCensusModule,
    userManager: userManagerModule,
    agency: agencyModule,
    urlAttributes: urlAttributesModule,
    client: clientsModule,
    urlCensus: urlCensusModule,
    auth: authModule,
    backgroundTasks: backgroundTasksModule,
    accountSetup: accountSetupModule,
    authorization: authorizationModule
  },
  state: {
    isCurrentSessionFetched: false,
    isDataUpdating: false,
    isChatHidden: true,
    isDataFetched: false,
    clients: [],
    adminClients: [],
    // 'empty' in array means that data didn't load
    adminRoutes: ['empty'],
    allowedRoutes: [],
    applicationRoutes: [],
    currentUser: EMPTY_USER,
    userRoles: [],
    selectedClient: null,
    unhashedClientId: null,
    urlStatuses: [],
    contentBriefStatuses: [],
    userGroups: [],
    stripeProducts: [],
    isNavbarCollapsed: true,
    isV2Api: false,
    // TODO: set it to true to see the PaymentPlanPopup; remove this after testing
    shouldSelectPaymentPlan: false,
    paymentPlans: [],
    stripeClientSecret: null,
    previousPage: '/dashboard',
  },
  mutations: {
    [ types.ADD_CLIENTS ]: function (state, clients) {
      state.clients = clients
    },
    [ types.ADD_AGENCIES ]: function (state, agencies) {
      state.agencies = agencies
    },
    [ types.ADD_USER_ROLES ]: function (state, userRoles) {
      state.userRoles = userRoles
      state.currentUser.userRoles = userRoles
    },
    [ types.ADD_UNHASHED_CLIENT_ID ]: function (state, id) {
      window.getUnhashedCurrentClientId = () => id
      state.unhashedClientId = id
    },
    [ types.ADD_ALLOWED_ROUTES ]: function (state, allowedRoutes) {
      state.allowedRoutes = allowedRoutes
    },
    [ types.ADD_APPLICATION_ROUTES ]: function (state, applicationRoutes) {
      state.applicationRoutes = applicationRoutes
    },
    [ types.ADD_ADMIN_ROUTES ]: function (state, adminRoutes) {
      adminRoutes.push({
        label: 'Other',
        link: '/other',
        route: ''
      })
      state.adminRoutes = adminRoutes
    },
    [ types.ADD_CURRENT_USER ]: function (state, currentUser) {
      state.currentUser = { ...EMPTY_USER, ...currentUser }
    },
    [ types.CHANGE_CHAT_STATUS ]: function (state) {
      state.isChatHidden = !state.isChatHidden
    },
    [ types.CHANGE_FETCHED_STATUS ]: function (state, status) {
      state.isDataFetched = status
    },
    [ types.SET_SELECTED_CLIENT ]: function (state, selectedClient) {
      if (selectedClient && selectedClient._id) {
        storageService.set('lastSelectedClientId', selectedClient._id)
      } else {
        storageService.remove('lastSelectedClientId')
      }
      state.selectedClient = selectedClient
    },
    [ types.UPDATE_CURRENT_USER ]: function (state, dataToUpdate) {
      state.currentUser = { ...state.currentUser, ...dataToUpdate, userRoles: state.userRoles }
    },
    [ types.ADD_ROLES ]: function (state, roles) {
      state.roles = roles
    },
    [ types.CHANGE_AGENCY_MODE ]: function (state, status) {
      state.isAgentModeEnabled = status
    },
    [ types.ADD_URL_STATUSES ]: function (state, statuses) {
      state.urlStatuses = statuses || []
    },
    [ types.ADD_CONTENT_BRIEF_STATUSES ]: function (state, statuses) {
      state.contentBriefStatuses = statuses || []
    },
    [ types.ADD_USER_GROUPS ]: function (state, groups) {
      state.userGroups = groups || []
    },
    [ types.ADD_STRIPE_PRODUCTS ]: function (state, products) {
      state.stripeProducts = products || []
    },
    [ types.UPDATE_COMPANY_GUIDELINE ]: function (state, { clientId, newGuideline }) {
      state.clients = state.clients.map(client => client._id === clientId ? Object.assign(client, { guideline: newGuideline }) : client)
      state.selectedClient.guideline = newGuideline
    },
    [ types.TOGGLE_FETCHED_STATUS ]: function (state, status) {
      state.isCurrentSessionFetched = status
    },
    [ types.TOGGLE_UPDATING_STATUS ]: function (state, status) {
      state.isDataUpdating = status
    },
    [ types.TOGGLE_COLLAPSED_STATUS ]: function (state, status) {
      state.isNavbarCollapsed = status
    },
  },
  actions: {
    getCurrentSession: async function ({ commit, dispatch }) {
      commit(types.TOGGLE_FETCHED_STATUS, false)
      try {
        const sessionData = await httpService.get('/get-current-session')
        commit(types.CHANGE_FETCHED_STATUS, true)
        if (!sessionData || !sessionData.data) {
          return false
        }
        const lastSelectedClientId = storageService.get('lastSelectedClientId', false)
        let selectedClient
        if (lastSelectedClientId) {
          selectedClient = sessionData.data.clients.find(client => client._id === lastSelectedClientId)
        }
        if (!selectedClient) {
          selectedClient = sessionData.data.default_client
        }
        commit(types.ADD_CLIENTS, sessionData.data.clients)
        commit(types.ADD_AGENCIES, sessionData.data.agencies)
        commit(types.ADD_CURRENT_USER, sessionData.data.current_user)
        // set earlier selected client by start application
        await dispatch('setSelectedClient', { selectedClient })
        commit(types.ADD_ROLES, sessionData.data.roles)
        commit(types.ADD_URL_STATUSES, sessionData.data.url_statuses)
        commit(types.ADD_CONTENT_BRIEF_STATUSES, sessionData.data.content_brief_statuses)
        const statuses = sessionData.data.url_statuses
        // store statuses and sections in briefsOverviewModule additionally 'cause we need filter received data in briefsOverviewModule module
        dispatch(briefsOverviewModule.actions.addStatuses.name, statuses, { root: true })
        const sectionsNames = selectedClient.sections.map(section => section.name)
        dispatch(briefsOverviewModule.actions.addSections.name, sectionsNames, { root: true })
        commit(types.TOGGLE_FETCHED_STATUS, true)
        commit(types.ADD_USER_GROUPS, sessionData.data.user_groups)
        commit(types.ADD_STRIPE_PRODUCTS, sessionData.data.stripe_products)
        dispatch('getUserRoles')
      } catch (err) {
        console.log(err)
        return false
      }
      return true
    },
    getUserRoles: async function ({ commit }) {
      const userRoles = await httpService.get('/get-user-roles')
      commit(types.ADD_USER_ROLES, userRoles)
    },
    changeChatStatus: async function ({ commit }) {
      commit(types.CHANGE_CHAT_STATUS)
    },
    getApplicationRoutes: function ({ commit  }) {
      const frontendRoutes = router.getRoutes().map(route => {
        let allowed = this.state.allowedRoutes.some(allowedRoute => route.regex.test(allowedRoute)) || route.path.startsWith('/user/')
        return {
          ...route,
          allowed: allowed
        }
      })
      commit(types.ADD_APPLICATION_ROUTES, frontendRoutes)
    },
    changeAgencyMode: function ({ commit }, status) {
      commit(types.CHANGE_AGENCY_MODE, status)
    },
    updateSelectedClientData: function ({ commit }, selectedClient) {
      selectedClient.changedFromNavbar = false
      commit(types.SET_SELECTED_CLIENT, selectedClient)
    },
    setSelectedClient: async function ({ commit, dispatch, rootState }, { selectedClient, updateRoles = false, changedFromNavbar = false }) {
      const previousClient = rootState.selectedClient ? rootState.selectedClient._id : null
      if (!selectedClient || selectedClient._id === previousClient) {
        return
      }
      selectedClient.changedFromNavbar = changedFromNavbar
      commit(types.SET_SELECTED_CLIENT, selectedClient)
      // we need getSession to fetch client-specific data.
      await dispatch('rankZoneCommon/getSession', { clientId: selectedClient._id }, { root: true })
      dispatch('setCurrentRole')
      updateRoles && dispatch('updateUserRolesByClients')
      const sectionsNames = selectedClient.sections.map(section => section.name)
      dispatch(briefsOverviewModule.actions.addSections.name, sectionsNames, { root: true })
    },
    createUpdateAnnotation: async function (storage, { method, ...params }) {
      const request = httpService[method]
      const response = await request(`/annotations`, params,
        { cancelErrorMessage: true, raiseError: true })
      if (!response || !response.data) {
        return {}
      }
      return response.data
    },
    removeAnnotation: async function (storage, id) {
      const response = await httpService.delete('/annotations', {
        params: { id },
        successMessage: 'Annotation removed successfully',
        raiseError: true
      })
      if (!response || !response.data) {
        return {}
      }
      return response.data
    },
    updateProfile: async function ({ commit  }, { clientId, dataToUpdate }) {
      const response = await httpService.patch(`/account/${clientId}`, dataToUpdate,
        { successMessage: 'Successfully Saved!' })
      if (!response || !response.data) {
        return
      }
      commit(types.UPDATE_CURRENT_USER, dataToUpdate)
    },
    changePassword: async function (store, { userId, dataToUpdate }) {
      const response = await httpService.patch(`/change-password/${userId}`, dataToUpdate)
      if (!response || !response.data) {
        return null
      }
      return response.data.is_old_password_correct
    },
    /**
     * if we set selectedClient with flag updateRoles == true we should update user and client settings
     */
    async updateUserRolesByClients ({ commit, state }) {
      const sessionData = await httpService.get('/get-current-session')
      if (!sessionData || !sessionData.data) {
        return
      }
      commit(types.ADD_CLIENTS, sessionData.data.clients)
      const newSelectedClient = sessionData.data.clients.find(item => item._id === state.selectedClient._id)
      const newRoleId = _.get(newSelectedClient, 'user_role_id')
      if (state.currentUser.current_role_id !== newRoleId) {
        commit(types.UPDATE_CURRENT_USER, {
          current_role_id: newSelectedClient.user_role_id,
          current_role_name: newSelectedClient.user_role })
      }
    },
    /**
     * user may be connected to different clients with different roles.
     * This action allows us to get role for just selected client
     *
     */
    getUserRoleByClient: function ({ commit }, { clientId, currentUserId }) {
      httpService.get(`/clients/${clientId}/users/${currentUserId}/current-role`,
        { raiseError: true })
        .then(res => {
          commit(types.UPDATE_CURRENT_USER, {
            current_role_id: res.data.current_role_id,
            current_role_name: res.data.current_role_name })
        }).catch(() => {})
    },
    setCurrentRole ({ commit, state }) {
      commit(types.UPDATE_CURRENT_USER, {
        current_role_id: state.selectedClient.user_role_id,
        current_role_name: state.selectedClient.user_role })
    },
    updateCompanyGuideline: function ({ commit }, { clientId, newGuideline }) {
      return httpService.patch(`/client/${clientId}`, { guideline: newGuideline },
        { raiseError: true, successMessage: 'Successfully Applied!' })
        .then(() => {
          commit(types.UPDATE_COMPANY_GUIDELINE, { clientId, newGuideline })
        })
    },
    toggleUpdatingStatus: function ({ commit }, status) {
      commit(types.TOGGLE_UPDATING_STATUS, status)
    },
    toggleFetchedStatus: function ({ commit }, status) {
      commit(types.TOGGLE_FETCHED_STATUS, status)
    },
    toggleCollapsedStatus: function ({ commit }, status) {
      commit(types.TOGGLE_COLLAPSED_STATUS, status)
    },
    /**
     * logout action
     */
    logout: async function ({ commit }) {
      // break all requests to make logout call faster
      await httpService.breakAllRequests()
      return httpService.axios({
        method: 'get',
        url: '/user/sign-out',
        baseURL: ''
      }).then(() => {
        commit(types.ADD_CLIENTS, null)
        commit(types.ADD_AGENCIES, null)
        commit(types.ADD_CURRENT_USER, null)
        commit(types.SET_SELECTED_CLIENT, null)
      }).catch(() => {
        commit(types.ADD_CLIENTS, null)
        commit(types.ADD_AGENCIES, null)
        commit(types.ADD_CURRENT_USER, null)
        commit(types.SET_SELECTED_CLIENT, null)
      })
    },
    selectPaymentPlan: async function({ commit }, { paymentPlanId, userId }) {
      // TODO: implement this action
      console.log('selectPaymentPlan', paymentPlanId, userId)
      
    },
    getStripeClientSecret: async function({ commit }) {
      try {
        const response = await httpService.get('/stripe/client-secret');
        
        commit(types.SET_STRIPE_CLIENT_SECRET, response.data?.client_secret || null)
      } catch (error) {
        console.error(error)
      }
    },
    resetStripeClientSecret: function({ commit }) {
      commit(types.SET_STRIPE_CLIENT_SECRET, null)
    },
  }
})
